import React, {useEffect} from 'react';
import ReportCard from "../../../../../components/reports/report-card.jsx";
import ReportUtils from "../../../../../utils/report-utils.js";
import {FaCircleExclamation, FaTriangleExclamation} from "react-icons/fa6";

const CardsContent = ({ data }) => {
    const cards = data?.cards ?? [];

    useEffect(() => {

        const values = [
            [String(cards?.[0].label), cards?.[0].value ?? 0],
            [String(cards?.[1].label), cards?.[1].value ?? 0]
        ];

        ReportUtils.createExportableTable(["Descrição", "Quantidade"], values, 'Cards')
    }, [cards]);

    return (
        <>
            <div className="flex flex-col">
                <div className="grid grid-cols-2">
                    <ReportCard title={null} value={null} className="relative">
                        <>
                            <h3>{cards?.[0]?.label}</h3>
                            <h2>{cards?.[0]?.value}</h2>

                            <div className="absolute bottom-5 right-3">
                                <FaTriangleExclamation size={20} className={'text-red-600'}/>
                            </div>
                        </>
                    </ReportCard>


                    <ReportCard
                        title={null}
                        value={null}
                        className="relative"
                        justTitle="Documentos a vencer nos próximos 45 dias"
                    >
                        <>
                            <h3>{cards?.[1]?.label?.replace(" (Próximos 45 dias)", "")}</h3>
                            <h2>{cards?.[1]?.value}</h2>

                            <div className="absolute bottom-5 right-3">
                                <FaCircleExclamation size={20} className={'text-[#f5a30a]'}/>
                            </div>
                        </>
                    </ReportCard>
                </div>
            </div>

            <div className="chart-divisor"/>
        </>
    );
};

export default CardsContent;
